import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Pagination from '../../../../../../components/Pagination';
import { TableHeader, TableBody } from './tableConfig';
import { dataProps, paginationProps } from '../../../../../../data/enums/Component';
import withErrorAndLoadingScreen from '../../../../../../utils/composition/withLoading';

const propTypes = {
  data: dataProps.value,
  pagination: paginationProps.value,
  onPageChange: PropTypes.func,
  permission: PropTypes.instanceOf(Object).isRequired,
};

const defaultProps = {
  onPageChange: () => null,
  data: dataProps.defaultValue,
  pagination: paginationProps.defaultValue,
};

const FundamentalsView = ({ ...props }) => {
  const {
    data,
    onPageChange,
    pagination,
    permission,
  } = props;

  return (
    <Fragment>
      <div className='table-wrap'>
        <table>
          {TableHeader({
            dataListLength: data.list.length,
            permission,
          })}

          <tbody>
            {data.list.map((bu) =>
              TableBody({
                data: bu,
                permission,
              })
            )}
          </tbody>
        </table>
      </div>
      <Pagination
        currentPage={pagination.page}
        limit={pagination.limit}
        totalItems={data.total}
        onPageChange={onPageChange}
      />
    </Fragment>
  );
};

FundamentalsView.propTypes = propTypes;

FundamentalsView.defaultProps = defaultProps;

const FundamentalsViewWithErrorAndLoading = withErrorAndLoadingScreen(FundamentalsView);

export default FundamentalsViewWithErrorAndLoading;
